import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import _ from "lodash";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { CustomTheme } from "../../../../types/customTheme";
import { handleDownloadPdf } from "./convert/handlePdf";
import { handleDownloadExcel } from "./convert/handleExcel";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
export interface ShiftHeaderProps {
  selectedDays: any;
  handleChangeSelectedDays: any;
  dropDownDays: any;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
    autoComplete: {
      marginTop: "4px",
      width: "200px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_highlight_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
      width: "100%",
      backgroundColor: theme.palette.background.entity_background,
      borderRadius: "10px",
      border: "none",
      [`& fieldset`]: {
        borderRadius: "10px",
        border: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
  }),
);

/**
 * SelectedDaysDropdown Component:
 *
 * This component handles the header section of the Shift component, including
 * sorting controls, location selection, and shift generation. It displays shift
 * information in a table-like format with sortable columns and provides options
 * for selecting shifts, generating reports, and handling user interactions.
 */
const SelectedDaysDropdown: React.FunctionComponent<ShiftHeaderProps> = ({
  selectedDays,
  handleChangeSelectedDays,
  dropDownDays,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const getOptionSelected = (option: any, anotherOption: any) => {
    return option.id === anotherOption.id;
  };
  const allSelected = dropDownDays.length === selectedDays.length;
  const getOptionLabel = (option: any) => `${option.label}`;
  const filter = createFilterOptions();
  const optionRenderer = (option: any, { selected }: any) => {
    const selectAllProps: any =
      option.id === "selectAll" && allSelected ? { checked: dropDownDays } : {};
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {getOptionLabel(option)}
        <Checkbox
          color="secondary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
      </div>
    );
  };

  const theme: CustomTheme = useTheme();

  return (
    <Autocomplete
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      size={"small"}
      id="locationSelectGlobal"
      color="inherit"
      options={dropDownDays}
      style={{ marginRight: "12px", width: "200px" }}
      value={selectedDays}
      getOptionLabel={(option: any) => option.label || ""}
      disableCloseOnSelect
      disableClearable
      onChange={handleChangeSelectedDays}
      classes={{ root: classes.autoComplete }}
      popupIcon={<ArrowDropDownIcon color={"inherit"} />}
      getOptionSelected={(option, value) => option.id === value.id}
      filterOptions={(options, params) => filter(options, params)}
      renderOption={optionRenderer}
      renderTags={() => null}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          className={classes.textField}
          placeholder="Day of Week"
        />
      )}
    />
  );
};

export default SelectedDaysDropdown;
